export const PRODUCT_IDENTIFIERS_TYPES = [
  { id: 'BLMB', displayValue: 'BLMB' },
  { id: 'RIC', displayValue: 'RIC' },
  { id: 'Valoren', displayValue: 'Valoren' },
  { id: 'WKN', displayValue: 'WKN' },
  { id: 'CUSIP', displayValue: 'CUSIP' },
  { id: 'Common Code', displayValue: 'Common Code' },
  { id: 'Series Number', displayValue: 'Series Number' },
  { id: 'PRIIP_CLOUD', displayValue: 'PRIIP Cloud Product Code' },
  { id: 'Sedol', displayValue: 'Sedol' },
  { id: 'FIC Issuance Mandate ID', displayValue: 'FIND ID' },
];
